import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const GiftMessageRemainingCount = props => {
  const { currentCount } = props;

  const remainingCharacters = 160 - currentCount;

  return (
    <div className="GiftMessageRemainingCount">
      {I18n.localize('cart.giftMessageCharactersRemaining', { value: remainingCharacters })}
      <style jsx>
        {`
          .GiftMessageRemainingCount {
            color: ${Theme.get('colors-black-80')};
            font-size: ${Theme.get('font-size-small-px')};
            letter-spacing: ${Theme.get('letter-spacing-px')};
          }
        `}
      </style>
    </div>
  );
};

GiftMessageRemainingCount.propTypes = {
  currentCount: PropTypes.number.isRequired,
};

export default GiftMessageRemainingCount;
